import React, { Component } from 'react';
import {getYoutubeTitle} from './getYoutubeTitle.js';
import ConditionedComponent from 'components/ConditionedComponent.js';

class YoutubeThumbnail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            videoId: this.props.videoId,
            name: '',
        };

        this.updateName(this.props.videoId);
    }

    onClickBuy() {
        window.open("https://www.discogs.com/sell/release/" + this.props.release.id, "_blank");
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.videoId !== this.state.videoId) {
            this.updateName(nextProps.videoId);
        }

        this.state.videoId = nextProps.videoId;

        return true;
    }

    async updateName(videoId) {
        let name = await getYoutubeTitle(videoId);
        this.setState({
            name: name
        });
    }

    getYoutubeThumbnail() {
        return 'https://img.youtube.com/vi/' + this.props.videoId + '/1.jpg';
    }

    onClickVideo() {
        this.props.loadVideo({videoId: this.props.videoId});
    }

    render() {
        return (
            <div className="youtube-discogs-container">
              <img
                onClick={() => this.onClickVideo()}
                className="youtube-thumbnail" src={this.getYoutubeThumbnail()}/>
              <div className="discogs-youtube-name">
                {this.state.name}
              </div>
              <ConditionedComponent condition={this.props.release !== undefined}>
                <div
                  onClick={(e) => this.onClickBuy(e)}
                  className="discogs-result-url">
                  Buy Vinyl
                </div>
              </ConditionedComponent>
            </div>
        );
    }
}

export default YoutubeThumbnail;
